import GenerateIcon from '@material-ui/icons/RotateRight';
import DeleteIcon from '@material-ui/icons/Delete';
import DisableIcon from '@material-ui/icons/HighlightOff';
import EnableIcon from '@material-ui/icons/CheckCircleOutline';
import EditIcon from '@material-ui/icons/Edit';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export default (options) => {
  const isDisabled = options.isDisabled || (k => k.disabled);
  const { getDownloadLicenseURL } = options;
  return {
    disable: {
      callbackProp: 'onDisableKey',
      getTooltip: apiKey => `${isDisabled(apiKey) ? 'Enable' : 'Disable'} API Key`,
      ariaLabel: apiKey => `${isDisabled(apiKey) ? 'Enable' : 'Disable'}`,
      idPrefix: 'disable-api-key-',
      getIcon: apiKey => (isDisabled(apiKey) ? EnableIcon : DisableIcon),
      getLabel: apiKey => `${isDisabled(apiKey) ? 'Enable' : 'Disable'} API Key`,
    },
    edit: {
      callbackProp: 'onEditKey',
      tooltip: 'Edit API Key',
      ariaLabel: 'edit',
      idPrefix: 'edit-api-key-',
      icon: EditIcon,
      label: 'Edit',
    },
    delete: {
      callbackProp: 'onDeleteKey',
      tooltip: 'Delete API Key',
      ariaLabel: 'delete',
      idPrefix: 'delete-api-key-',
      icon: DeleteIcon,
      label: 'Delete API Key',
    },
    download: {
      tooltip: 'Download license file',
      getLink: getDownloadLicenseURL,
      download: true,
      ariaLabel: 'download license',
      idPrefix: 'download-api-key-',
      label: 'Download license file',
    },
    generate: {
      callbackProp: 'generateApiKeySecret',
      tooltip: 'Regenerate API Key secret',
      ariaLabel: 'generate secrate',
      idPrefix: 'generate-secret-api-key-',
      icon: GenerateIcon,
      label: 'Delete API Key',
    },
    menu: {
      callbackProp: 'onOpenMenu',
      tooltip: 'Open API Key menu',
      useEvent: true,
      idPrefix: 'menu-api-key-',
      icon: MoreVertIcon,
      label: 'More',
    },
  };
};
